import moment from 'moment';

export const processes = [
  {
    process_date: moment(),
    process_id: null,
    time_start: null,
    time_stop: null,
    operator: null,
    plan_qty: null,
    prod_qty: null,
    accepted_qty: null,
    rej_qty: null,
    verified_sign: null,
    remarks: null,
    reasons_for_rej: Array.from({ length: 34 }, () => ({
      reason: '',
      rej_qty: null,
    })),
    reasons_for_less_prod: Array.from({ length: 34 }, () => ({
      reason: '',
      rej_qty: null,
    })),
  },
];

export const initialState = {
  isSubmitted: false,
  is_admin_request_no: null,
  is_admin_request: null,
  report_prepared_by: null,
  report_approved_by: null,
  dailyProduction_date: new Date(),
  part_id: null,
  assy_line:null,
  line_leader:null,
  job_card_no:null,
  processes: Array.from({ length: 1 }, () => ({ ...processes[0] })),
};
